import {Component, computed, inject, input, signal, viewChild} from '@angular/core'
import {Text} from '../text'
import {CdkTextareaAutosize} from '@angular/cdk/text-field'
import {MatFormField, MatInput} from '@angular/material/input'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {Calculus} from '../../../services/calculus/calculus'

export type TText =
  'newFull'
  | 'newPart'
  | 'currentFull'
  | 'currentPart'
  | 'newLoan'
  | 'renewal'
  | 'offer'
  | 'amortizationBase'
  //
  | 'custBoundLoan'
  | 'custSavings'
  | 'custPrivateBanking'
  | 'custCorp'
  | 'custPartner'
  | 'custImportant'
  | 'custPotential'
  //
  | 'decisionOwn'
  | 'decisionOther'

@Component({
  selector: 'spb-text-item',
  imports: [
    Text,
    CdkTextareaAutosize,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './text-item.html',
  styleUrl: './text-item.scss'
})
export class TextItem {

  public type = input.required<TText>()

  public text = viewChild(Text)

  public calculus = inject(Calculus)

  public customer = computed(() => {
    return this.calculus.owners().at(0)?.name

  })
  public amount = signal<string>('<BELOPP>')
  public date = signal<string>('<DATUM>')
  public months = signal<string>('<X>')
  public discount = signal<string>('<X>')
  public x = signal<string>('<X>')
}
